import { render, staticRenderFns } from "./ImportObserveTableMenu.vue?vue&type=template&id=bb9fae90&"
import script from "./ImportObserveTableMenu.vue?vue&type=script&lang=js&"
export * from "./ImportObserveTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports